import { ProgramEventStatus } from '@citruscamps/citrus-client'
import React from 'react'

interface IProps extends React.HTMLAttributes<HTMLSpanElement> {
  status: ProgramEventStatus
}

export const AppointmentTypeStatusBadge = ({ status, className, ...props }: IProps) => {
  return (
    <span
      className={`badge rounded-pill text-capitalize text-bg-${
        { draft: 'warning', live: 'success', canceled: 'danger' }[status] || 'light'
      }${className ? ` ${className}` : ''}`}
      {...props}
    >
      {status}
    </span>
  )
}
